import request from '@/utils/request';
import qs from 'qs';

//查询业务员
export function querySalesman(data) {
  // let params = qs.stringify(data);
  let params = qs.parse(data);
  return request({
    url: '/manager/selectSaleMan',
    method: 'get',
    headers: {
      Accept: '*/*',
    },
    params: params,
  });
}

//添加业务员
export function addSalesman(params) {
  return request({
    url: '/manager/addSaleMan',
    method: 'post',
    headers: {
      Accept: '*/*',
    },
    params,
  });
}

//删除业务员
export function deleteSalesman(params) {
  return request({
    url: '/manager/removeSaleMan',
    method: 'post',
    headers: {
      Accept: '*/*',
    },
    params,
  });
}
